import 'jquery-mask-plugin';

export default () => {
  const $modal = $('.feedback-popup');

  $('.js-feedback-popup').on('click', function (event) {
    event.preventDefault();
    const tel = $(this).attr('href').split('tel:')[1];
    const $link = $modal.find('.feedback-popup__phone');

    $link
      .text(tel)
      .attr('href', `tel:${tel}`)
      .unmask()
      .mask('+0 (000) 000-00-00');

    $.magnificPopup.open({
      type: 'inline',
      items: [
        {
          src: $modal,
        }
      ],
      closeOnBgClick: false,
      fixedContentPos: true,
    });
  });

  $('.js-feedback-input').mask('+0(000)000-00-00');

  $('.js-feedback-form').on('submit', function (event) {
    event.preventDefault();
    const $form = $(this);

    $.ajax({
      type: "post",
      url: $form.attr('action'),
      data: $form.serialize(),
      success: function () {
        $.magnificPopup.close();
      },
      error: function (data) {
        console.log('Error: ', data.status);
        alert('Error: ')
      }
    })
  })
}


// WEBPACK FOOTER //
// ./resources/assets/js/blocks/feedback-popup/index.js